// import WebFont from 'webfontloader';
import Hamburger from '../modules/hamburger'; 
import initializeGlider from '../modules/initialize-glider';


export default {
  init() { },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    window.addEventListener('load', () => {
      document.body.classList.add('js-loaded');
    })

    //Lettura viewport
    let vw = document.body.clientWidth * 0.01;
    let vh = window.screen.availHeight * 0.01;
    document.documentElement.style.setProperty('--vw', `${vw}px`);
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    const is_touch_enabled = () => { 
      return ( 'ontouchstart' in window ) ||  
            ( navigator.maxTouchPoints > 0 ) ||  
            ( navigator.msMaxTouchPoints > 0 ); 
    }

    if (!is_touch_enabled()) {
      document.body.classList.toggle('is-not-touchable');
    }

    window.addEventListener('resize', () => {
      // We execute the same script as before
      vw = document.body.clientWidth * 0.01;  
      document.documentElement.style.setProperty('--vw', `${vw}px`);
      vh = window.screen.availHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });

    let allHtml = document.querySelector('html'); 
    Hamburger.register('body',{
        onOpen: () => {
          allHtml.style.overflow = 'hidden';
        },
        onClose: () => {
          allHtml.style.overflow = 'auto';
        },
    });

    //Swipe 
    let menuPanel = document.querySelector('.js-menuPanel');
    let menuBgImage = document.querySelector('.js-MenuBgImage');
    let swipeUp = document.querySelector('.js-swipeup'); 
    let opacityZero = document.querySelectorAll('.js-Opacity');

    if(swipeUp){
      swipeUp.addEventListener('touchstart', handleTouchStart, false);
      swipeUp.addEventListener('touchmove', handleTouchMove, false);
      swipeUp.addEventListener('touchend', handleTouchEnd, false);
    }

    let startY = 0;
    let touchobj = null;
    let triggerPoint = window.screen.availHeight/2;
    
    function enterMenuAnimation(kindOfAnimation) { 
      menuPanel.classList.add('js-btnOnHover');
      menuBgImage.classList.add(kindOfAnimation); 
      opacityZero.forEach(el => {
        el.style.opacity = '0'; 
      });
    }

    function exitMenuAnimation(kindOfAnimation) { 
      menuPanel.classList.remove('js-btnOnHover');
      menuBgImage.classList.remove(kindOfAnimation);
      opacityZero.forEach(el => {
        el.style.opacity = '1'; 
      }); 
    }

    function handleTouchStart(e){
      touchobj = e.changedTouches[0];
      startY = parseInt(touchobj.clientY);
    }

    function handleTouchMove(e){
      e.preventDefault();
      let dist = 0;
      touchobj = e.changedTouches[0];
      dist = -(parseInt(touchobj.clientY) - startY);

      let distanceForMenuWrapper = ((dist > triggerPoint)? -triggerPoint : (dist < 0)? 0 : -(dist)) + 'px';
      swipeUp.style.top = distanceForMenuWrapper;       

      if(dist > triggerPoint){
        e.preventDefault();
        menuPanel.parentNode.classList.add('activeSwipe');
        const hrefValue = document.querySelector('.Button--MenuLink a');
        window.location.href = hrefValue.getAttribute('href');
      } else { 
        enterMenuAnimation('fade-in'); 
      }
    }
    
    function handleTouchEnd(e){ 
      e.preventDefault();
      swipeUp.setAttribute('style', '');  
      exitMenuAnimation('fade-in'); 
    }

    //Fine Swipe 

    //Change background on hover menu btn

    if(swipeUp && document.body.clientWidth > 1024){
      swipeUp.addEventListener('mouseenter', function() {
        enterMenuAnimation('fade-in');
      })
      swipeUp.addEventListener('mouseleave', function() {
        exitMenuAnimation('fade-in');
      })
    }

    //fine change background on hover menu btn

    //START ACCORDION KEEP ITEM OPEN
    if(vw <= 1022) { 
      const accordions = el => {
          const accordionItems = document.querySelectorAll(el);
          let item_headings = document.querySelectorAll(el + ' .accordionItemHeading');
          let item_description = document.querySelectorAll(' .accordionItemDescription');
  
          item_headings.forEach( heading => {
              heading.addEventListener('click', () => {
              if(heading.parentNode.classList.contains('is-active')){
                  heading.parentNode.classList.remove('is-active')
              } else {
                  accordionItems.forEach( item => {
                  item.classList.remove('is-active')
                  })
                  heading.parentNode.classList.add('is-active');

                  item_description.forEach( description => {
                    description.classList.add('fade-in-bottom');
                  })
              }
              })
          });
        };

        accordions('.js-accordion');
      }  //END ACCORDION

    const jobAccordions = el => {
      const accordionItems = document.querySelectorAll(el);
      let item_headings = document.querySelectorAll(el + ' .accordionItemHeading');
      let item_description = document.querySelectorAll(' .accordionItemDescription');

      item_headings.forEach( heading => {
          heading.addEventListener('click', () => {
          if(heading.parentNode.classList.contains('is-active')){
              heading.parentNode.classList.remove('is-active')
          } else {
              accordionItems.forEach( item => {
              item.classList.remove('is-active')
              })
              heading.parentNode.classList.add('is-active');

              item_description.forEach( description => {
                description.classList.add('fade-in');
              })
          }
          })
      });
    };
    
    jobAccordions('.js-job-accordion');


    const jobPopulatingForm = () => {
      let jobAccordions = document.querySelectorAll('.js-job-accordion');

      jobAccordions.forEach(accordion => {
        let jobButton = accordion.querySelector('.js-job-button');

        jobButton.addEventListener('click', function () {
          let jobTitleDiv = accordion.querySelector('.js-job-title');

          if (jobTitleDiv) {
              let jobTitle = jobTitleDiv.textContent;
              let inputROLE = document.querySelector('input[name="ROLE"]');
              if (inputROLE) {
                  inputROLE.value = jobTitle;
              }
          }
        });

      });

    }
    jobPopulatingForm();

    const fixAnchor = () => {
      let anchors = document.querySelectorAll('.js-job-button');
      anchors.forEach(anchor => {
        anchor.addEventListener('click', function() {
          setTimeout(() => {
            window.scrollBy(0, -100);
          }, 1);
        });
      });
    }
    fixAnchor();

    initializeGlider();

  }, //fine finalized
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js